import { Heading, Section } from "@carbon/react";
import { FC } from "react";

export type WidgetHeaderProps = {
  title: string;
  description?: string;
};
const WidgetHeader: FC<WidgetHeaderProps> = ({ title, description }) => (
  <div>
    <Section level={4}>
      <Heading>{title}</Heading>
    </Section>
    <div>{description && <p className="text-textSecondary line-clamp-2">{description}</p>}</div>
  </div>
);

export default WidgetHeader;
